
import img1 from "../assets/images/combo-report/1759816571069.png";
import img2 from "../assets/images/combo-report/1759816612031.png";
import img3 from "../assets/images/combo-report/1759816637285.webp";
import img4 from "../assets/images/combo-report/1759816627469.png";
import img5 from "../assets/images/combo-report/1759816646135.webp";

export const mockData = {
  plan: [
    {
      id: "navratri-report",
      title: "Diwali Maha Combo - Get 3 Reports for ₹2100",
      description: "Personalized report with free consultation to unlock clarity, success & prosperity this Navratri.",
      priceOriginal: "₹4999",
      priceFinal: "₹1995",
      astroConsultationPrice: 0,
      expressDeliveryPrice: 0
    }
  ],
  sidebarOffers: [
    {
      title: "Navratri Offer 1",
      image: img1
    },
    {
      title: "Personalized Report",
      image: img2
    },
    {
      title: "Kundli Analysis",
      image: img3
    },
    {
      title: "Yearly Predictions",
      image: img4
    }
  ],

  astrologerImage: img5,

  heroProducts: [
    {
      title: "Yearly Report",
      image: "https://images.unsplash.com/photo-1643093881599-01810caf2548?w=100&h=120&fit=crop&crop=center"
    },
    {
      title: "Premium Kundli",
      image: "https://images.unsplash.com/photo-1545320222-9b9bbf26430b?w=100&h=120&fit=crop&crop=center"
    },
    {
      title: "Personalized Report",
      image: "https://images.unsplash.com/photo-1709906602242-e1d35fc553b1?w=100&h=120&fit=crop&crop=center"
    }
  ],

  stats: [
    {
      rating: "4.8/5",
      label: "Customer Ratings"
    },
    {
      rating: "Celebrity Astrologer",
      label: "Trusted by B-Town Celebs"
    },
    {
      rating: "3 Million+ Followers",
      label: "Strong community on Instagram & YouTube"
    },
    {
      rating: "10 Lakh+ Reports Delivered",
      label: "Prepared with care and accuracy"
    }
  ],

  offerings: [
    {title: "Life Changing Report (Numerology)", description:"Decoding your Moolank, Bhagyank, and personality strengths and challenges. And your Lucky numbers, days, colors, name corrections suggestions, and simple remedies like mantras, Rudraksha, gemstones, and bracelets."},
    {title: "Life Journey Report (Astrology)", description:"A thorough study of planetary positions, houses, and yogas based on your birth chart. Special remedies, auspicious times, gemstones, mantras, and puja suggestions for pacifying planetary defects."},
    {title: "Love Report (Only In English)", description:"A detailed analysis of your emotional patterns, attraction energy, and relationship potential through your birth chart. Clear guidance on Love, Emotions, understanding and friction points."},
  ],

  astrologerProfile: {
    image: img5,
    description: "Acharya Ji is an award-winning authority in Astrology, Numerology, and Vastu Shastra, carrying forward a rich legacy of over a decade. Trusted by celebrities, corporates, and seekers worldwide, he blends timeless wisdom with practical solutions for modern life.",
    description2: "A Renowned Spiritual luminary and TEDx speaker, Acharya Ji has guided millions across the globe with his transformative insights. Having graced prestigious platforms, he continues to simplify complex Vedic knowledge into actionable guidance.",
    description3: "His mission is clear: to empower individuals with clarity, remedies, and confidence—helping them unlock opportunities, overcome challenges, and shape a brighter future."
  },

  featuredLogos: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=600&h=200&fit=crop&crop=center",

  testimonials: [
    {
      name: "Ritu Sharma, Delhi",
      feedback: "I was confused about my marriage decision. The 3-in-1 report gave me clarity and the remedies worked beautifully. I feel more confident about my future."
    },
    {
      name: "Aman Verma, Mumbai",
      feedback: "The Life Journey Report predicted my job change almost to the exact month. I’m amazed at how accurate it was."
    },
    {
      name: "Priya Nair, Bangalore",
      feedback: "The Love Report explained issues in my relationship and gave simple remedies. Within weeks, I saw a positive change."
    },
    {
      name: "Rohit Malhotra, Chandigarh",
      feedback: "Earlier I wasted money on generic astrology apps. This was detailed, personalized and worth every rupee."
    },
    {
      name: "Sneha Kapoor, Pune",
      feedback: "Acharya Ji’s reports are life-changing. The consultation call gave me answers I had been seeking for years."
    },
    
  ]
};